import { useCallback, useState } from 'react';
import { Box, Theme } from '@mui/material';

export interface WalletIconProps {
  icon?: string;
  className?: string;
}

export function WalletIcon({ icon, className }: WalletIconProps) {
  const [imgError, setImgError] = useState(false);
  const onError = useCallback(() => setImgError(true), []);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const iconStyles = (theme: Theme) => ({
    display: 'block',
    width: 22,
    height: 22,
    borderRadius: theme.shape.borderRadiusXs,
    color: theme.palette.text.secondary,
    objectFit: 'contain',
  });

  return icon && !imgError ? (
    <Box
      component="img"
      sx={iconStyles}
      alt=""
      className={className}
      src={icon}
      onError={onError}
    />
  ) : (
    <Box
      sx={theme => ({
        ...iconStyles(theme),
        backgroundColor: theme.palette.grey.A200,
      })}
      className={className}
    />
  );
}
